import React from 'react'
import Suppliers from 'pages/app/inventory/Suppliers'
import Orders from 'pages/app/inventory/Orders'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import DraftOrdersSmartview from 'widgets/smartviews/inventory/DraftOrdersSmartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import { PageHeader } from 'ui/layouts'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { OnNavigatePipeline } from '@morningtrain/react-navigation'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import { useEnvValue } from '@morningtrain/react-helpers'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import * as UI from 'ui'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function Overview (props) {
  const [deviceIsAuthorized] = useEnvValue('device.is_authorized', false)

  return (
    <AdminPageWithSmartview slideInSmartview={deviceIsAuthorized}>
      <Translator namespace='inventory.overview'>
        <PageHeader title={<TranslatedTitle name='title'/>}>
          <UI.ButtonWrap>
            <WhenDeviceAuthorized>
              <MountSmartviewOnClick smartview={<DraftOrdersSmartview/>} replace={false}>
                <UI.Button>
                  <Translation name='actions.view_draft_orders'/>
                </UI.Button>
              </MountSmartviewOnClick>
            </WhenDeviceAuthorized>
          </UI.ButtonWrap>
        </PageHeader>
        <Suppliers/>
        <WhenDeviceNotAuthorized>
          <OnNavigatePipeline>
            <MountSmartviewOnPipe smartview={<DraftOrdersSmartview/>} replace/>
          </OnNavigatePipeline>
        </WhenDeviceNotAuthorized>
      </Translator>
    </AdminPageWithSmartview>
  )
}
